export enum PaymentStatus {
  Failure = 'failure',
  Paid = 'paid',
  Processing = 'processing',
}
